module.exports = __webpack_public_path__ + "img/o-d-downloads.d948d1fe.svg";